import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Home, Plane, Car } from 'lucide-react';
export function Location() {
  return <section className="py-24 px-6 bg-paper" data-id="element-72">
      <div className="max-w-6xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-74">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-75">
            Location & Travel
          </h2>
          <p className="text-ink-light text-lg" data-id="element-76">
            Everything you need to know to get here.
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto" data-id="element-77">
          <div className="space-y-6" data-id="element-78">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-paper-alt p-8 rounded-sm border border-ink/5" data-id="element-79">
              <div className="flex items-center gap-3 mb-4 text-sage" data-id="element-80">
                <Home className="w-6 h-6" data-id="element-81" />
                <h3 className="text-2xl" data-id="element-82">Accommodations</h3>
              </div>
              <p className="text-ink-light mb-2 font-medium" data-id="element-83">
                Marriott Marquis San Francisco
              </p>
              <p className="text-ink-light text-sm leading-relaxed mb-4" data-id="element-84">
                We have a room block reserved at the Marriott Marquis in
                downtown SF. Book online or call <strong data-id="element-85">415-442-6029</strong>{' '}
                and ask for the
                <strong data-id="element-86"> "Kan Family Reunion"</strong> block. We recommend
                booking sooner rather than later — availability is limited and
                rates may change.
              </p>
              <a href="https://book.passkey.com/gt/221097763?gtid=9675fd84eac4ada5b09fa42c78a98747" target="_blank" rel="noopener noreferrer" className="inline-block text-sm font-medium bg-sage/10 text-sage px-4 py-2 rounded-sm hover:bg-sage/20 transition-colors" data-id="element-87">
                Book Your Room Online →
              </a>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-paper-alt p-8 rounded-sm border border-ink/5" data-id="element-88">
              <div className="flex items-center gap-3 mb-4 text-amber" data-id="element-89">
                <Plane className="w-6 h-6" data-id="element-90" />
                <h3 className="text-2xl" data-id="element-91">Getting Here</h3>
              </div>
              <ul className="space-y-3 text-sm text-ink-light" data-id="element-92">
                <li className="flex items-start gap-2" data-id="element-93">
                  <Plane className="w-4 h-4 mt-0.5 shrink-0" data-id="element-94" />
                  <span data-id="element-95">
                    <strong data-id="element-96">Fly:</strong> San Francisco International Airport
                    (SFO) is 30 minutes away. Oakland (OAK) is also nearby.
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-97">
                  <Car className="w-4 h-4 mt-0.5 shrink-0" data-id="element-98" />
                  <span data-id="element-99">
                    <strong data-id="element-100">Getting Around:</strong> Parking in SF is limited
                    and expensive. We suggest using Waymo's self-driving cars,
                    which will drive to all venues, or Uber/Lyft.
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}